import axios from 'axios';
import { AUTH_LOGOUT_URL, authSessionExpired } from '@actions/auth-actions';
import { hasAuthToken } from '@utils/auth-utils';

const getAuthorizationHeader = headers => {
  if (!headers) {
    return null;
  }
  // axios turns the request headers into an AxiosHeaders instance (case insensitive).
  return typeof headers.get === 'function' ? headers.get('Authorization') : headers.Authorization;
};

// Signs the user out when the server rejects their auth token (HTTP 401),
// i.e. the token expired (after the inactivity timeout or its maximum
// lifetime), or it was revoked (sign out, password or permission change, or
// revoked by an admin).
//
// Only requests that sent an auth token are handled, so failed sign in
// attempts and requests to other servers are left alone. Sign out requests
// are skipped too, since signing out already clears the auth.
export const handleUnauthorizedResponse = dispatch => error => {
  const { config, response } = error || {};
  if (
    response?.status === 401 &&
    getAuthorizationHeader(config?.headers) &&
    config?.url !== AUTH_LOGOUT_URL &&
    hasAuthToken()
  ) {
    dispatch(authSessionExpired());
  }
  return Promise.reject(error);
};

// Installs the interceptor, returns its id (to eject it).
export const setupAuthInterceptor = dispatch => axios.interceptors.response.use(
  response => response,
  handleUnauthorizedResponse(dispatch)
);
